import {http} from "../http-common";

export interface RecentStudentActivity {
    id: number;
    entityName: string;
    createdAt: string;
}

const getRecent = (id: string) => http.get<RecentStudentActivity[]>(`/students/${id}/recent-activities`);

const get = (id: any) => {
        return http.get<any>(`/students/${id}/history`);
};

const AccountHistoryService = {
    get,
    getRecent,
}

export default AccountHistoryService;
